import { Box, Chip, LinearProgress, Stack, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

function parseAmount(v?: string | null): number {
  if (v == null || v === '') return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function formatAmount(v?: string | null): string {
  const n = parseAmount(v);
  return n.toLocaleString('en-US', { maximumFractionDigits: 6 });
}

export function DualPoolProgressCell({
  current,
  target,
  reward,
  cycleStatus,
}: {
  current?: string;
  target?: string;
  reward: string;
  cycleStatus: string;
}) {
  const t = useTranslate();
  const cur = parseAmount(current);
  const tgt = parseAmount(target);
  const unlocked = tgt > 0 && cur >= tgt;
  // Calendar window closed (may still be awaiting Finalize).
  const windowEnded =
    cycleStatus === 'SETTLED' ||
    cycleStatus === 'ENDED_UNQUALIFIED' ||
    cycleStatus === 'PENDING_SETTLEMENT';
  const pendingSettlement = cycleStatus === 'PENDING_SETTLEMENT';
  const badge = unlocked
    ? pendingSettlement
      ? t('module.socialTrading.poolPendingSettlement')
      : t('module.socialTrading.poolUnlocked')
    : windowEnded
      ? t('module.socialTrading.poolUnmet')
      : t('module.socialTrading.poolLocked');
  const pct = tgt > 0 ? Math.min(100, Math.round((cur / tgt) * 100)) : 0;

  return (
    <Stack spacing={0.75} sx={{ minWidth: 180 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Box sx={{ flex: 1, minWidth: 80 }}>
          <LinearProgress
            variant="determinate"
            value={pct}
            sx={{ height: 8, borderRadius: 1 }}
            color={unlocked ? 'success' : 'primary'}
          />
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          {formatAmount(current)} / {formatAmount(target)}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={0.75} alignItems="center">
        <Typography variant="body2">{formatAmount(reward)} USDC</Typography>
        <Chip
          size="small"
          label={badge}
          color={
            unlocked
              ? pendingSettlement
                ? 'warning'
                : 'success'
              : windowEnded
                ? 'default'
                : 'warning'
          }
          variant={unlocked && !pendingSettlement ? 'filled' : 'outlined'}
        />
      </Stack>
    </Stack>
  );
}
